import React from 'react';

const CustomIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 17.5L9 17.5"
      stroke="#2F2F34"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 13.5L13 13.5"
      stroke="#2F2F34"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 14.5C20.5 18.2712 20.5 20.1569 19.2552 21.3284C18.0104 22.5 16.0069 22.5 12 22.5H11.2273C7.96607 22.5 6.33546 22.5 5.20307 21.7022C4.87862 21.4736 4.59058 21.2025 4.3477 20.8971C3.5 19.8313 3.5 18.2966 3.5 15.2273V12.6818C3.5 9.71865 3.5 8.23706 3.96894 7.05375C4.72281 5.15142 6.31714 3.65088 8.33836 2.94135C9.59563 2.5 11.1698 2.5 14.3182 2.5C16.1173 2.5 17.0168 2.5 17.7352 2.7522C18.8902 3.15765 19.8012 4.0151 20.232 5.10214C20.5 5.77832 20.5 6.62494 20.5 8.31818V14.5Z"
      stroke="#2F2F34"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 12.5C3.5 10.6591 4.99238 9.16667 6.83333 9.16667C7.49912 9.16667 8.28404 9.28333 8.93137 9.10988C9.50652 8.95576 9.95576 8.50652 10.1099 7.93136C10.2833 7.28404 10.1667 6.49912 10.1667 5.83333C10.1667 3.99238 11.6591 2.5 13.5 2.5"
      stroke="#2F2F34"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CustomIcon;
